import {all, fork} from 'redux-saga/effects';
import {watchUserAuthentication} from './authentication';

export default function* watchUserAuthenticationSagas() {
  yield all([fork(watchUserAuthentication)]);
}
